<template>
  <footer>
    <template v-if="show == 'index'">
      <div class="wechat">
        <img src="~@/assets/images/wechat.png" alt="">
      </div>
      <div class="abus" @mouseout="showMeg(false)">
        <ul class="nav f-nav">
          <li v-for="(item,key) of tltmsg" :key="key" @mouseover="showMeg(key)" @click="toMessenger(key)">
            <template v-if="key <= 2">
              <i :class="'iconfont ' + item.cname"></i>
            </template>
          </li>
          <li><i class="iconfont messs-nav icon-iconfonticonfontxinxi" @click="toMessenger(5,'nsy')"></i></li>
        </ul>
        <div class="tlt-msg" v-if="msgmouse">{{ msgmouse }}</div>
      </div>
    </template>
    <template v-if="show == 'noIndex'">
      <div class="fot-box">
        <div class="fot-nav">

          <ul class="fot-ul" style="margin-bottom:30px;" @mouseout="showFotMeg(null)">
            <li class="active" @mouseover="showFotMeg(-10,1)"><i class="iconfont icon-dianhua"></i></li>
            <!-- <li @mouseover="showFotMeg(18,2)" @click="tagqq"><i class="iconfont icon-qq"></i> </li> -->
            <li @mouseover="showFotMeg(15,3)" @click="tagemail"><i class="iconfont icon-icon--"></i></li>
            <li @mouseover="showFotMeg(-40,4)"><i class="iconfont icon-dingwei1"></i></li>
            <li @mouseover="showFotMeg(20,5)"><i class="iconfont icon-erweima"></i></li>
            <!-- <li @mouseover="showFotMeg(145,6)"><i class="iconfont icon-tongxunlu1"></i></li>  -->
            <li><i class="iconfont messs-nav icon-iconfonticonfontxinxi" @click="toMessenger(5,'sy')"></i></li>
          </ul>

          <ul class="fot-ul" @click="scrollUpward">
            <li style="line-height:40px;"><i class="iconfont icon-Upward" style="font-size:16px;"></i></li>
          </ul>

          <div ref="fot-tlt-msg" :class="{'fot-tlt-msg':fotindex}">

            <div v-if="fotindex == 1" class="fot-tel" style="width:130px;">
              <span class="tel-h" style="margin-top:3px;"><i class="iconfont icon-dianhua"></i></span>
              <h3>{{ $t('hot-footer.m14') }}</h3>
              <p>021-52180789</p>
            </div>

            <div v-if="fotindex == 2" class="fot-tel" style="width:130px;">
              <span class="tel-h" style="margin-top:3px;"><i class="iconfont icon-qq"></i></span>
              <h3>QQ</h3>
              <p>26807376</p>
            </div>

            <div v-if="fotindex == 3" class="fot-tel" style="width:130px;">
              <span class="tel-h" style="height:30px;margin-left:-10px"><i class="iconfont icon-icon--"></i></span>
              <h3 style="">{{ $t('hot-footer.m65') }}</h3>
              <p style="margin-left:20px;">service@hotdb.com</p>
            </div>

            <div v-if="fotindex == 4" class="font-ads">
              <div class="fot-tel clearfix" style="width:250px;margin-bottom:10px;">
                <span class="tel-h"><i class="iconfont icon-dingwei1"></i></span>
                <h3>{{ $t('hot-footer.m47') }}：</h3>
                <p>{{ $t('hot-footer.074') }}</p>
              </div>
              <div class="fot-tel clearfix" style="width:250px;margin-bottom:10px;">
                <span class="tel-h"><i class="iconfont icon-dingwei1"></i></span>
                <h3>{{ $t('hot-footer.m49') }}：</h3>
                <p>{{ $t('hot-footer.m67') }}</p>
              </div>
              <div class="fot-tel clearfix" style="width:250px;margin-bottom:10px;">
                <span class="tel-h"><i class="iconfont icon-dingwei1"></i></span>
                <h3>{{ $t('hot-footer.m48') }}：</h3>
                <p>{{ $t('hot-footer.m68') }}</p>
              </div>
              <div class="fot-tel clearfix" style="width:250px;">
                <span class="tel-h"><i class="iconfont icon-dingwei1"></i></span>
                <h3>{{ $t('hot-footer.m50') }}：</h3>
                <p>{{ $t('hot-footer.m70') }}</p>
              </div>
            </div>

            <div v-if="fotindex == 5" class="fot-tel" style="width:160px;height:160px">
              <p><img src="~@/assets/images/wechat.png" style="width:100%" alt=""></p>
            </div>

            <div v-if="fotindex == 6" class="fot-tel" style="width:130px;">
              <span class="tel-h" style="margin-top:3px;"><i class="iconfont icon-tongxunlu1"></i></span>
              <h3>{{ $t('hot-footer.m66') }}</h3>
              <p>138 1798 4195</p>
            </div>
          </div>
        </div>
      </div>
    </template>

    <Messenger :showMessenger="showMessenger" @toMessenger="toMessenger"/>

  </footer>
</template>

<script>
import config from "@/config"
import Messenger from "@/pages/Messenger"

export default {
  name: 'HotFooter',
  data() {
    return {
      msgIndex: null,
      msgmouse: false,
      showMessenger: false,
      fotindex: '',
    }
  },
  props: ['show'],
  computed: {
    tltmsg() {
      return config.home().contactUs
    }
  },
  methods: {
    tagqq() {
      window.target = '_blank'
      window.location.href = 'tencent://message/?uin=26807376'
    },
    tagemail() {
      window.target = '_blank'
      window.location.href = 'mailto:service@hotdb.com'
    },
    scrollUpward() {
      document.body.scrollTop = 0 // chrome
      document.documentElement.scrollTop = 0 // firefox
    },
    showMeg(index) {
      if(index === false) {
        this.msgmouse = false
        return
      }
      this.msgmouse = this.tltmsg[index]['text']
    },
    showFotMeg(ht, idx) {
      if(ht === null) {
        this.msgmouse = false
        this.fotindex = ''
        return
      }
      let msg = this.$refs['fot-tlt-msg']
      msg.style.top = ht + 'px'
      this.fotindex = idx
    },
    toMessenger(key, sy) {
      if(key == 1) {
        window.target = '_blank'
        window.location.href = 'mailto:service@hotdb.com'
      }
      if(key == "5") {
        this.showMessenger = !this.showMessenger
      }
    }
  },
  components: {
    Messenger
  }
}
</script>

<style scoped>
footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>




// WEBPACK FOOTER //
// src/components/HotFooter.vue